/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'tls-fingerprint-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const tlsFingerprintLabel = `${prefix}.tlsFingerprintLabel`;

export const ENGLISH = {
    [tlsFingerprintLabel]: 'TLS Fingerprint',
};
